/* istanbul ignore file */
export * from './FilterHistogram';
